var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ui-timeline-item_arrow"},[_c('app-icon',{attrs:{"name":_vm.ICON_NAMES.ARROW_RIGHT}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }